export default __webpack_public_path__ + "static/media/christmas4.f099a1c2.png";